import { createJSONStorage } from "jotai/utils";

// Web Storage throws when it is missing, denied (private mode, blocked site data) or full; callers degrade to no persistence.
const safe = (storage: () => Storage) => ({
  getItem: (key: string) => {
    try {
      return storage().getItem(key);
    } catch {
      return null;
    }
  },
  setItem: (key: string, value: string) => {
    try {
      storage().setItem(key, value);
      return true;
    } catch {
      return false;
    }
  },
  removeItem: (key: string) => {
    try {
      storage().removeItem(key);
    } catch {}
  },
  // jotai only syncs tabs for a real Storage instance, so a wrapper has to bring its own.
  subscribe: (key: string, callback: (value: string | null) => void) => {
    const onStorage = (event: StorageEvent) => {
      if (event.key === key && event.storageArea === storage()) callback(event.newValue);
    };
    globalThis.addEventListener("storage", onStorage);
    return () => globalThis.removeEventListener("storage", onStorage);
  },
});

export const safeLocalStorage = safe(() => localStorage);
export const safeSessionStorage = safe(() => sessionStorage);

// An atom's set returns setItem's result, and a story's beforeEach would hand that boolean to Storybook as its cleanup.
export const safeJSONStorage = <T>(storage = safeLocalStorage) =>
  createJSONStorage<T>(() => ({
    ...storage,
    setItem: (key: string, value: string) => {
      storage.setItem(key, value);
    },
  }));
